import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainInput", "input"]

  connect() {
  }

  toggleChecked() {
    this.inputTargets.forEach((input)=>{
      input.checked = this.mainInputTarget.checked
    })
  }
}
